import type { SentimentBreakdown as SentimentBreakdownData } from '@ekorank/shared'

interface Props {
  sentiment: SentimentBreakdownData
}

export function SentimentBreakdown({ sentiment }: Props) {
  const total = sentiment.positive + sentiment.neutral + sentiment.negative + sentiment.unscored
  if (total === 0) return null

  const segments = [
    { label: 'Positive', value: sentiment.positive, color: 'bg-secondary' },
    { label: 'Neutral',  value: sentiment.neutral,  color: 'bg-primary/40' },
    { label: 'Negative', value: sentiment.negative, color: 'bg-error/70' },
    { label: 'Unscored', value: sentiment.unscored, color: 'bg-outline/30' },
  ].filter((s) => s.value > 0)

  return (
    <div className="bg-surface-container rounded-xl border border-outline-variant/10 p-4 sm:p-6 mb-6 sm:mb-10">
      <h3 className="text-sm font-mono text-outline uppercase tracking-widest mb-1">Sentiment of Mentions</h3>
      <p className="text-xs text-outline mb-6">How AI engines describe you when they do mention you</p>
      <div className="flex h-3 rounded-full overflow-hidden">
        {segments.map((s) => (
          <div key={s.label} className={s.color} style={{ width: `${(s.value / total) * 100}%` }} />
        ))}
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 mt-3 text-xs text-on-surface-variant">
        {segments.map((s) => (
          <span key={s.label} className="flex items-center gap-1.5">
            <span className={`inline-block w-2 h-2 rounded-full ${s.color}`} />
            {s.label}: {s.value}
          </span>
        ))}
      </div>
    </div>
  )
}
